import React from 'react';

import { ServerMessageHandler } from '@swf/notification';

import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Okay,
  TXTWCL_Your_method_isnXt_available_ri_ELL
} from './WithdrawMethodNotAvailable.messages.json';

interface Props {
  defaultMessage: string;
  onClose(): void;
}

const WithdrawMethodNotAvailable: React.FC<Props> = ({ defaultMessage, onClose }) => (
  <Prompt
    onClose={onClose}
    variant="first"
    title={{
      translation: TXTWCL_Your_method_isnXt_available_ri_ELL
    }}
    primaryButton={{
      translation: TXTWCL_Okay
    }}
    alert={<ServerMessageHandler message={defaultMessage} />}
  />
);

export default WithdrawMethodNotAvailable;
